// Pricing migration 32 (ADO-3985), T13: which multi-buy deal the dialog shows, if any.
//
// One dialog for the whole app (ADR-004: Zustand for client-side global state), drawn by
// `MultibuyDealDialogHost` at the composition root, so a card, a list row, the order review or
// any other surface opens it without wiring a handler through its hosts. The deal is named by
// the product it was opened from and its offer code; the host reads the deal itself from the
// deals store, so the dialog always shows the latest progress. "Also on this product" swaps the
// deal in place (R4 07o: "it never stacks a second one").

import { create } from 'zustand';

export interface DealDialogTarget {
  /** The product the deal was opened from: its deals are the ones "Also on this product". */
  readonly skuCode: string;
  readonly offerCode: string;
}

interface DealDialogState {
  readonly target: DealDialogTarget | null;
  openDeal: (target: DealDialogTarget) => void;
  /** Swap the open dialog to another deal of the same product (R4 07o). */
  showDeal: (offerCode: string) => void;
  close: () => void;
}

export const useDealDialogStore = create<DealDialogState>()((set, get) => ({
  target: null,
  openDeal(target) {
    set({ target });
  },
  showDeal(offerCode) {
    const { target } = get();
    if (target !== null) set({ target: { ...target, offerCode } });
  },
  close() {
    set({ target: null });
  },
}));
